function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "15",
  height: "14",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M6.5 13a.5.5 0 01-.492-.41L6 12.5v-3a.5.5 0 01.992-.09L7 9.5V12h5.924V1H7v2.5a.5.5 0 01-.41.492L6.5 4a.5.5 0 01-.492-.41L6 3.5v-3a.5.5 0 01.41-.492L6.5 0h6.925a.5.5 0 01.492.41l.008.09v12a.5.5 0 01-.41.492l-.09.008H6.5zM2.716 9.409l-.07-.058-2.5-2.502A.5.5 0 01.09 6.21l.057-.07 2.5-2.5a.5.5 0 01.765.639l-.057.069-1.645 1.647H10.5a.5.5 0 01.09.991l-.09.008-8.793.001 1.647 1.648a.5.5 0 01.057.638l-.058.07a.5.5 0 01-.637.057z",
  fill: "#54585D",
  fillRule: "nonzero"
})));